import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Grid, MenuItem } from '@material-ui/core';
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import access, { loyalty } from 'config/access';
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import {
  loginValidate,
  signupDetailsValidate,
} from 'helpers/validateRules/auth';
import useForm from '../../../helpers/useForm';
import { styles } from './styles';
import billtoConfiguration from 'apis/billtoConfiguration/billtoConfiguration'
import Loader from 'components/Loader/Loader';
import Context from 'context/context';
import Table from 'components/Table/Table';
import { exportHeaders } from "./export";
import useDebounce from "helpers/useDebounce";
import searchIcon from "assets/img/Search_Icon.png";

// material-ui icons
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import audit from "apis/audit/audit";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";
import HistoryTable from "components/Table/History/HistoryTable";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";




// custom TextField
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      background: 'transparent',
    },
    '& .MuiFormLabel-root': {
      background: 'transparent',
    },
    '& .MuiInputBase-input': {
      background: 'transparent',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#000 !important',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#000 !important',
    },
  },
})(TextField);

const initialValues = {
  customer_billto_account_number: '',
  contract_code: '',
  loyalty: '',
  system_managed: '',
  // password: '',
};

const roles = [
    {
        id: true,
        name: 'Yes',
    },
    {
        id: false,
        name: 'No'
    }
    // {
    //     id: 9,
    //     name: 'Accounting'
    // },
    // {
    //     id: 12,
    //     name: 'Observer'
    // }
]

const headings = ['Id', 'Billto', 'Contract Code', 'Loyalty', 'System Managed','Status','View Detail','History'];

function BilltoConfiguration() {
  const history = useHistory();
  const location = useLocation();
  const { getAudit } = audit();
  const { state, dispatch } = useContext(Context);
  const {
    values,
    setErrors,
    handleChange,
  } = useForm(initialValues, handleCreate);
  const { getAllBillto, create, allAdminExport,search } = billtoConfiguration();
  const classes = styles();
  const [open, setOpen] = useState(false);
  const [states, setstates] = useState({
    showPassword: false,
    tooltipName: '',
    tooltipCondition: false,
    disableButton: false,
    historyLoader: false,
  });
  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const { t, i18n } = useTranslation();
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [isLoading, setIsLoading] = useState(false);
  const [exportData, setExportData] = useState([]);
  const { historyLoader } = states;
  const [errors, setError] = useState({});
  const [dataContract, setDataContract] = useState([]);

  

  useEffect(() => {
    handleGetAllAdmins();
  }, [offset]);

  // handling search api
  useEffect(() => {
    let offsetValue = location?.state?.offset;
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } 
    else if (offsetValue) {
      setOffset(offsetValue);
      location.state = undefined;
    } 
    else {
      setOffset(1);
    }
  }, [searchBounceValues]);

  async function handleGetAllAdmins() {
    try {
      dispatch({ type: 'SET_LOADING', payload: true });
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      let res = await getAllBillto(values);
      setData(res.data);
      setCount(res.count);
      setDataContract(res?.contract)
      dispatch({ type: 'SET_LOADING', payload: false });
    } 
    catch (e) {
      console.log({ e });
    }
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  // search api func
  const handleSearch = async () => {
  
  
    try {
      let values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await search(values);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res) {
        setData(res.data);
        setCount(res.count);
        return;
      }
      setData([]);
    } 
    catch (e) {
      dispatch({ type: "SET_LOADING", payload: false });
      console.log({ e });
    }
  };

  function reset() {
    handleChange({ name: 'customer_billto_account_number', value: '' });
    handleChange({ name: 'contract_code', value: '' });
    handleChange({ name: 'loyalty', value: '' });
    handleChange({ name: 'system_managed', value: '' });
    // handleChange({ name: 'password', value: '' });
  }

  const handleClose = () => {
    setOpen(false);
    setError({})
    reset();
  };

  async function handleCreate() {
    try {
   let emptyerror=false
      if(values.customer_billto_account_number==''){
        setError(prevState => ({ ...prevState, customer_billto_account_number: 'Billto cannot be empty' }));
        emptyerror =true;

      }
      if(typeof values.loyalty != "boolean"){
        setError(prevState => ({ ...prevState, loyalty: 'Loyalty cannot be empty' }));
        emptyerror =true;
        
      }
      if(values.contract_code==''){
        setError(prevState => ({ ...prevState, privilege_code: 'Contract Code cannot be empty' }));
        emptyerror =true;
  
      }
      if(typeof values.system_managed != "boolean"){
        setError(prevState => ({ ...prevState, system_managed: 'System Managed cannot be empty' }));
        emptyerror =true;
      }
      if(typeof values.system_managed == "boolean" &&typeof values.loyalty == "boolean"){
        if(values.loyalty != values.system_managed){
          setError(prevState => ({ ...prevState, system_managed: 'System Managed and Loyalty Should be Same' }));
          setError(prevState => ({ ...prevState, loyalty: 'System Managed and Loyalty Should be Same' }));

          emptyerror =true;
        }
      }
      if(emptyerror){
        return;
      }
      dispatch({ type: 'SET_LOADING', payload: true });
      let res = await create(values);
      dispatch({ type: 'SET_LOADING', payload: false });
      if (res?.status_code == 201) {      
        setError(prevState => ({ ...prevState, customer_billto_account_number: 'Billto Already Exsits' }));
        emptyerror=true
       
      }
      if (res?.status_code == 202) {
        setError(prevState => ({ ...prevState, customer_billto_account_number: 'Invalid Billto' }));

            //  setError({billto: 'Invalid Billto' });
        emptyerror=true
       
      }
      if(emptyerror){
        return;
      }
      handleClose();
      if (res.status_code == 200) {
        toast.success('Created Successfully', { toastId: 'create-admin' });
        setError({})
      } 
      
      else {
        toast.error(res?.message, { toastId: 'create-admin' });
        setError({})
      }
      handleGetAllAdmins();
    } 
    catch (e) {
      console.log({ e });
      setError({})
    }
  }
  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id.toString(),
        key: "billtoconfig",
      };
      let res = await getAudit(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } 
    catch (e) {
      console.log({ e });
    }
  };
  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // export api function
  // const handleExport = async () => {
  //   let values = {};
  //   if (searchValue) {
  //   values = { ...values, searchValue };
  //   }
  //   if (states.salesCategory) {
  //   values = { ...values, salesCategory: states.salesCategory };
  //   }
  //   if (states.redemptionFrom && states.redemptionTo) {
  //   values = {
  //       ...values,
  //       redemptionFrom: parseInt(states.redemptionFrom),
  //       redemptionTo: parseInt(states.redemptionTo),
  //   };
  //   }
  //   if (states.orgName) {
  //   values = { ...values, orgName: states.orgName };
  //   }
  //   if (typeof states.isActive === "boolean") {
  //   values = { ...values, isActive: states.isActive };
  //   }
  //   dispatch({ type: "SET_LOADING", payload: true });
  //   setIsLoading(true);
  //   let res = await allAdminExport(values);
  //   if (res && res.data) {
  //   setExportData(res.data.map(obj => {
  //       return {
  //       ...obj,
  //       product_primary_class_id: obj?.product_primary_class_id + String.fromCharCode(8203),
  //       primary_major_class_code: obj?.primary_major_class_code + String.fromCharCode(8203),
  //       primary_submajor_class_code: obj?.primary_submajor_class_code + String.fromCharCode(8203),
  //       primary_minor_class_code: obj?.primary_minor_class_code + String.fromCharCode(8203)
  //       }
  //   }));
  //   dispatch({ type: "SET_LOADING", payload: false });
  //   setIsLoading(false);
  //   if (res.data.length === 0) {
  //       toast.success(t("No Data Found"), { toastId: "no-report-date" });
  //       return false;
  //   }
  //   return true;
  //   }
  // };

  const invalidChar = ['~', '`', '!', '#', '$', '%', '^', '*', '(', ')', '_', '+', '=', '', ';', ':', '<', '.', '>', '?', '|', '[', ']', '{', '}', '"', "'"]
  const blockInvalidChar = e => invalidChar.includes(e.key) && e.preventDefault();
  // console.log(states.historyLoader,'raja')
  return (
    <>
      <div>
        <div className={classes.btnDiv}>
        <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flex: 0.99 }}>
                <CssTextField
                    placeholder="Search for Billto"
                    type={"text"}
                    variant="outlined"
                    onKeyDown={blockInvalidChar}
                    className={classes.searchInput}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {searchValue.length > 0 ? (
                                    <CloseOutlinedIcon
                                        className={classes.searchInputIcon}
                                        onClick={() => {
                                            setSearchValue("");
                                            setOffset(1);
                                            handleGetAllAdmins();
                                        }}
                                    />
                                ) : (
                                    <img
                                        src={searchIcon}
                                        alt=""
                                        width="20px"
                                        className={classes.searchInputIcon}
                                    />
                                )}
                            </InputAdornment>
                        ),
                    }}
                    value={searchValue}
                    onChange={(e) => {
                        setSearchValue(e.target.value);
                        setOffset(1);
                        if (e.target.value.length == 0) {
                            handleGetAllAdmins();
                        }
                    }}
                    onClick={() => {
                        setOffset(offset);
                    }}
                />                            
            </div>
            <CSVLink
                id="csv"
                data={exportData}
                headers={exportHeaders.map((head) => head)}
                filename={"UserAccount"+moment(new Date()).format("MM-DD-YYYY,h:mm A")+".csv"}
                className={classes.CSVlink}
            />
            {/* <button
                disabled={isLoading}
                className={classes.exportBtn}
                onClick={async () => {
                let res = await handleExport();
                    if (res) {
                        document.getElementById("csv").click();
                    }
                }}
            >
                Export
            </button> */}
            <button className={classes.createBtn} onClick={handleClickOpen}>
              {t('Create')}
            </button>             
        </Grid>
          
        </div>
        <Loader Loading={state.loading} top={'35%'}>
          <div className={classes.responsiveTable}>
            <Grid item xs={12} sm={12} lg={12}>
              <Table
                headings={headings} //.map(i => <div>{i}</div>)}
                data={data.map((p, i) => [
                  [p?.id],
                  [p?.customer_billto_account_number],
                  [p?.contract_code],
                  [
                    p?.loyalty == true ? (
                      <span style={{ color: "green" }} key={i}>
                        {t('YES')}
                      </span>
                    ) : p.loyalty == false ? (
                      <span style={{ color: "red" }} key={i}>
                        {t('NO')}
                      </span>
                    ) : "-"
                  ],
                  [
                    p?.system_managed == true ? (
                      <span style={{ color: "green" }} key={i}>
                        {t('YES')}
                      </span>
                    ) : p?.system_managed == false ? (
                      <span style={{ color: "red" }} key={i}>
                        {t('NO')}
                      </span>
                    ) : "-"
                  ],
                  [
                    p?.is_active == true ? (
                      <span style={{ color: "green" }} key={i}>
                        {t('YES')}
                      </span>
                    ) : p?.is_active == false ? (
                      <span style={{ color: "red" }} key={i}>
                        {t('NO')}
                      </span>
                    ) : "-"
                  ],
                  [
                    <RemoveRedEyeIcon
                      key={i}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/dashboard/billto-configuration-detail", {
                            allAdminId: p?.id,
                          offset,
                        });
                      }}
                    />,
                  ],
                  [
                    <HistoryIcon
                      key={i}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setStates({
                          historyDialog: true,
                          historyLoader: true,
                        });
                        handleGetHistoryData(p?.id);
                      }}
                    />
                  ],
                ])}
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            </Grid>
          </div>
        </Loader>
      </div>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby='alert-dialog-slide-description'
        fullWidth
        maxWidth='xs'
        disableBackdropClick
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <CloseOutlinedIcon
            className={classes.closeIcon}
            onClick={handleClose}
          />
          <div
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            {t('Create New Billto Configuration')}
          </div>          
          <DialogContentText id='alert-dialog-slide-description'>
            <Grid
              container
              item
              xs={12}
              spacing={Object.keys(errors).length > 2 ? 0 : 2}
            >
              <Grid item xs={12}>
                <CssTextField
                  id='Billto'
                  label={t('Billto')}
                  type={'number'}                  
                         onWheel={(e) => e.target.blur()}
                  onfocus="this.removeAttribute('readonly')"
                  value={values.customer_billto_account_number}
                  fullWidth
                  onChange={(e) => {
                    if(errors?.customer_billto_account_number){
        setError(prevState => ({ ...prevState, customer_billto_account_number: '' }));
                    }
                    handleChange({ name: 'customer_billto_account_number', value: e.target.value });
               
                  }}
                />
                {errors.customer_billto_account_number && (
                  <span className={classes.errorMsg}>{errors?.customer_billto_account_number}</span>
                )}
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  id='Contract Code'
                  label={t('Contract Code')}
                  select
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  value={values.contract_code}
                  onChange={(e) => {
                    console.log(values,"errors?.billto")

                    if(errors?.contract_code){
                    setError(prevState => ({ ...prevState, contract_code: '' }));
                    }
                    handleChange({ name: 'contract_code', value: e.target.value });
                  }}
                >
                  {dataContract?.map((item) => {
                    return (
                      <MenuItem key={t(item?.contract_code)} value={item?.contract_code}>
                        {t(item?.contract_code)}
                      </MenuItem>
                    );
                  })}
                </CssTextField>
                {errors.contract_code && (
                  <span className={classes.errorMsg}>{errors.contract_code}</span>
                )}
              </Grid>
              {/* <Grid item xs={12}>
                <CssTextField
                  id='email'
                  label={t('Email')}
                  type={'email'}
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton edge='end'>
                          <EmailOutlinedIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={values.email}
                  onChange={(e) => {
                    handleChange({ name: 'email', value: e.target.value });
                  }}
                />
                {errors.email && (
                  <span className={classes.errorMsg}>{errors?.email}</span>
                )}
              </Grid> */}
              <Grid item xs={12}>
                <CssTextField
                  id='Loyalty'
                  label={t('Loyalty')}
                  select
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  value={values.loyalty}
                  onChange={(e) => {
                    if(errors?.loyalty){
                  
                    setError(prevState => ({ ...prevState, loyalty: '' }));
                    }
                    handleChange({ name: 'loyalty', value: e.target.value });
                  }}
                >
                  {roles.map((item) => {
                    return (
                      <MenuItem key={t(item.name)} value={item.id}>
                        {t(item.name)}
                      </MenuItem>
                    );
                  })}
                </CssTextField>
                {errors.loyalty && (
                  <span className={classes.errorMsg}>{errors.loyalty}</span>
                )}
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  id='System Managed'
                  label={t('System Managed')}
                  select
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  value={values.system_managed}
                  onChange={(e) => {
                    if(errors?.system_managed){
                   
        setError(prevState => ({ ...prevState, system_managed: '' }));
                    }
                    handleChange({ name: 'system_managed', value: e.target.value });
                  }}
                >
                  {roles.map((item) => {
                    return (
                      <MenuItem key={t(item.name)} value={item.id}>
                        {t(item.name)}
                      </MenuItem>
                    );
                  })}
                </CssTextField>
                {errors.system_managed && (
                  <span className={classes.errorMsg}>{errors.system_managed}</span>
                )}
              </Grid>

              
            </Grid>
            <div className={classes.popupBtnDiv}>
              <button className={classes.submitBtn} onClick={handleCreate}>
                {!state.loading ? t('Submit') : `${t('Please wait')}..`}
              </button>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog ? true : false}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {t('History')}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div className={classes.emptyDataText}>
            <div>
              <FolderOpenIcon className={classes.emptyDataIcon} />{" "}
            </div>
            <div className={classes.errorMsg}>{"No Data Found"}</div>
          </div>
          )}
        </div>
      </Dialog>
    </>
  );
}

export default BilltoConfiguration;
